const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const USER_GROUP_KEY = "user_group";
const ACTIONS_KEY = "actions";

class AuthSession {
  getSession() {
    return {
      access_token: this.getAccessToken() || "",
      refresh_token: this.getRefreshToken() || "",
      user_group: this.getUserGroup() || ""
    };
  }

  setSession(tokens, options = {}) {
    const shouldMerge = Boolean(options.merge);
    if (!tokens || typeof tokens !== "object") {
      this.clearSession();
      return;
    }

    const baseSession = shouldMerge
      ? this.getSession()
      : { access_token: "", refresh_token: "", user_group: "" };

    const nextSession = {
      access_token:
        typeof tokens.access_token === "string" && tokens.access_token
          ? tokens.access_token
          : baseSession.access_token,
      refresh_token:
        typeof tokens.refresh_token === "string" && tokens.refresh_token
          ? tokens.refresh_token
          : baseSession.refresh_token,
      user_group:
        typeof tokens.user_group === "string" && tokens.user_group
          ? tokens.user_group
          : baseSession.user_group
    };

    if (
      !nextSession.access_token ||
      !nextSession.refresh_token ||
      !nextSession.user_group
    ) {
      this.clearSession();
      return;
    }

    localStorage.setItem(ACCESS_TOKEN_KEY, nextSession.access_token);
    localStorage.setItem(REFRESH_TOKEN_KEY, nextSession.refresh_token);
    localStorage.setItem(USER_GROUP_KEY, nextSession.user_group);
  }

  normalizeActions(actions) {
    if (Array.isArray(actions)) {
      return [...new Set(actions.filter(action => typeof action === "string" && action))];
    }

    if (typeof actions === "string") {
      return [...new Set(actions.split(",").map(action => action.trim()).filter(Boolean))];
    }

    return [];
  }

  setActions(actions) {
    const normalizedActions = this.normalizeActions(actions);
    if (!normalizedActions.length) {
      localStorage.removeItem(ACTIONS_KEY);
      return;
    }

    localStorage.setItem(ACTIONS_KEY, JSON.stringify(normalizedActions));
  }

  getActions() {
    const rawActions = localStorage.getItem(ACTIONS_KEY);
    if (!rawActions) {
      return [];
    }

    try {
      return this.normalizeActions(JSON.parse(rawActions));
    } catch (error) {
      return this.normalizeActions(rawActions);
    }
  }

  hasAction(actionName) {
    return typeof actionName === "string" && this.getActions().includes(actionName);
  }

  clearSession() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_GROUP_KEY);
    localStorage.removeItem(ACTIONS_KEY);
  }

  getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  getUserGroup() {
    return localStorage.getItem(USER_GROUP_KEY);
  }

  isAuthenticated() {
    return Boolean(
      this.getAccessToken() && this.getRefreshToken() && this.getUserGroup()
    );
  }
}

export default new AuthSession();
